import { useField } from "formik";
import {
  EfsMelcoModelsDesign,
  EfsMelcoModelsDesignElement,
} from "melco-shared-logic";
import { Alert } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useMissingFontValidation } from "../../hooks/designMappings/useMissingFontValidation";

type MissingFontHintProps = {
  design: EfsMelcoModelsDesign;
  currentDesignElement: EfsMelcoModelsDesignElement | undefined;
  formikPrefix: string;
};

export const MissingFontHint: React.FC<MissingFontHintProps> = ({
  design,
  currentDesignElement,
  formikPrefix,
}) => {
  const { t } = useTranslation();

  const [{ value: mappingId }] = useField<string>(
    [formikPrefix, "mapping_id"].join(".")
  );
  const designId = design.id ?? "";
  const letteringElementId = currentDesignElement?.id ?? "";

  const [isMissingFont] = useMissingFontValidation(
    mappingId,
    designId,
    letteringElementId
  );

  if (!isMissingFont) {
    return null;
  }

  return (
    <Alert
      type="error"
      message={t(
        "designMappings.detail.form.designConfiguration.missingFontHint.title"
      )}
      description={t(
        "designMappings.detail.form.designConfiguration.missingFontHint.content"
      )}
      withBackground
    />
  );
};
